import {useEffect, useState} from "react"
import {createUseStyles} from 'react-jss'
import Card from "../components/Card"
import {useTranslation} from "react-i18next"
import {Link, useParams} from "react-router-dom";
import InfoCard from "../components/InfoCard"
import {Colors} from "../constants/colors"
import BackButton from "../components/BackButton"
import { useAppSelector } from "../redux/hooks"
import { PayDeviation } from "../redux/types"
import PayArticleList from "../components/PayArticle/PayArticleList";

const PayDeviationDetails = () => {
  const styles = useStyles()
  const {t} = useTranslation(['deviations', 'common']);
  const {deviationId} = useParams()

  const [deviationDetails, setDeviationDetails] = useState<PayDeviation>()
  const deviationsOnPage = useAppSelector(state => state.payDeviations.deviationsOnPage)

  useEffect(() => {
    if (deviationsOnPage.length > 0) {
      var deviation = deviationsOnPage.find(x => x.id === deviationId)
      if (deviation != null) {
        setDeviationDetails(deviation)
      }
    }
  }, [deviationsOnPage, deviationId])

  return (
    <>
      <BackButton/>
      <Card className={styles.card}>
        <h2>
          {t('deviationDetails', {ns: 'deviations'})}
        </h2>
      </Card>
      <div className={styles.infoCardContainer}>
        <InfoCard title={t('information', {ns: 'common'})} className={styles.infoCard}>
          <div className={styles.row}>
            <div className={styles.label}>{t('id', {ns: 'common'})}</div>
            <div>{deviationDetails?.externalId}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('date', {ns: 'common'})}</div>
            <div>{deviationDetails?.date}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('description', {ns: 'deviations'})}</div>
            <div>{deviationDetails?.description}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('grossAmount', {ns: 'deviations'})}</div>
            <div>{deviationDetails?.grossValue.amount.toLocaleString('sv-SE', {minimumFractionDigits: 2})} {deviationDetails?.grossValue.currencyCode.toUpperCase()}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('employee', {ns: 'common'})}</div>
            <div>
              <Link to={`/employees/${deviationDetails?.employee.id}`}>
                  {deviationDetails?.employee.name}
              </Link>
            </div>
          </div>
        </InfoCard>
        <InfoCard title={t('payArticles', {ns: 'common'})} className={styles.articleCard}>
          {deviationDetails?.payArticles && <PayArticleList payArticles={deviationDetails?.payArticles} />}
        </InfoCard>
      </div>
    </>
  )
}

export default PayDeviationDetails

const useStyles = createUseStyles({
  card: {
    marginBottom: 20
  },
  infoCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    columnGap: 20
  },
  infoCard: {
    flex: 1
  },
  articleCard: {
    flex: 3
  },
  row: {
    flex: 1,
    marginBottom: 10,
  },
  label: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 10,
    textTransform: 'uppercase',
    fontSize: 13,
    color: Colors.gray3
  }
})
